import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

import { UserService } from '@/app/services';
import { scope } from '@/constants';
import { environment } from '@/environments/environment';

@Component({
  selector: 'app-login',
  imports: [],
  template: '',
})
export class LoginComponent implements OnInit {
  private router: Router = inject(Router);
  private userService: UserService = inject(UserService);
  private auth: AuthService = inject(AuthService);

  isAuthenticated = toSignal(this.auth.isAuthenticated$);

  ngOnInit(): void {
    const pageUrl = new URL(this.router.url, 'https://example.com');
    const firstechQueryParamVal = pageUrl.searchParams.get('firstech');
    if (firstechQueryParamVal !== undefined && firstechQueryParamVal !== null) {
      const deepLink = pageUrl.searchParams.get('goto');

      this.userService.login({
        authorizationParams: {
          connection: environment.ftUsersConnection,
          scope: scope,
        },
        appState: {
          target: deepLink ?? '/home/dashboard',
        },
      });
    } else {
      this.userService.login();
    }
  }
}
